
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./~/octa-channels/~/engine.io-client/lib/index.js
// module id = 7OQX
// module chunks = 1